// extracted by mini-css-extract-plugin
module.exports = {"leftPanel":"leftPanelStyles__leftPanel--3RWMN","fullHeight":"leftPanelStyles__fullHeight--3ZNU1","image":"leftPanelStyles__image--2N4et"};